var map = {
	"./ico-apple-2x.png": "e888",
	"./ico-bluesky-2x.png": "036d",
	"./ico-facebook-2x.png": "1041",
	"./ico-google-2x.png": "f861",
	"./ico-instagram-2x.png": "9298",
	"./ico-linkedin-2x.png": "7d32",
	"./ico-pinterest-2x.png": "7578",
	"./ico-telegram-2x.png": "9376",
	"./ico-threads-2x.png": "f9d2",
	"./ico-tiktok-2x.png": "579f",
	"./ico-twitter-2x.png": "34d7",
	"./ico-waze-2x.png": "942c",
	"./ico-youtube-2x.png": "d55c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5886";